import React from 'react';
import {
    Link,
    useLocation
} from 'react-router-dom'
import { useDispatch } from "react-redux";
import {
    addNextPage,
    addFormData
} from "../redux/index";
import nykreditIcons from '../images/icons/Nykredit_Icons.svg';
import styled from "styled-components";

const StyledLink = styled(Link)`
    height: 88px;
    width: 335px;
    background: ${props => props.theme.buttonColor.default};
    margin-bottom: ${props => props.marginbottom || 0};
    display: ${props => (props.ismobile ? 'none' : 'inline-block')};
    position: static;

    ${props => props.theme.mediaQueries.medium}{
        margin-bottom: 0;
    }

    :visited {
        text-decoration: none;
        color: #000;
    }

    :hover {
        background: ${props => props.theme.buttonColor.hover};
        box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
        text-decoration: none;
    }
`

const IconLeft = styled.svg`
    background-image: url(${props => props.iconleft});
    background-repeat: no-repeat;
    display: inline-block;
    margin: 28px 0 28px 16px;
    height: 32px;
    width: 32px;
    float: left;
`

const Text = styled.h1`
    color: #FFFFFF;
    display: inline-block;
    margin-left: 19px;
    margin: 29px 0 29px 19px;

    ${props => props.theme.mediaQueries.medium}{
        font-size: 1.1rem;
    }
`

const IconRight = styled.svg`     
    background-image: url(${nykreditIcons}#Chevron_white);
    transform: rotate(270deg);
    background-repeat: no-repeat;
    height: 24px;
    width: 22px;
    display: inline-block;
    float: right;
    margin: 33px 16px 33px 0;
`

const ButtonOrange = ({
    className,
    to,
    reduxNextPage,
    text,
    isMobile,
    marginBottom,
    iconLeft,
    ...props
}) => {
    const dispatch = useDispatch();

    const handleOnClick = () => {
        if (reduxNextPage) {
            dispatch(addNextPage(reduxNextPage));
        }
    }

    return (
        <StyledLink
            to={{
                pathname: to,
                state: {
                    background: {
                        pathname: "/",
                        search: sessionStorage.getItem('locationSearch')
                    }
                }
            }}
            onClick={handleOnClick}
            {...props}
            marginbottom={marginBottom}
            ismobile={isMobile}
        >
            <IconLeft iconleft={iconLeft} {...props} />
            <Text>{text}</Text>
            <IconRight />
        </StyledLink>
    )
}

export default ButtonOrange;